import MessageBase from "./MessageBase";
export default class MessageJoin extends MessageBase {
  constructor(room, client) {
    super("Leave");
    this.Room = room;
    this.Client = client;
  }
}
